<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @最后编辑: Betway
 * @最后修改时间: 2022-07-22 10:08:16
-->
<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'message-detailLog'"
      :headers="headers"
      :hideAddBtn="!hasBtn('add-push-message-logs')"
      pageName="addMessageLog"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="[
        'title',
        'created_utc_datetime',
        'preferred_name',
        'client_type',
        'status',
        'is_read',
      ]"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.created_utc_datetime="{ item }">
        {{ item.created_utc_datetime | changeDate("YYYY/MM/DD HH:mm:ss") }}
      </template>
      <template #item.is_read="{ item }">
        <span>{{ INT(item.is_read) }}</span>
      </template>
      <template #item.title="{ item }">
        <span
          :title="INT(item.title)"
          style="max-width: 200px"
          class="d-inline-block text-truncate"
          >{{ INT(item.title) }}</span
        >
      </template>
      <template #item.preferred_name="{ item }">
        <span>{{ INT(item.preferred_name) }}</span>
      </template>
      <template #item.client_type="{ item }">
        <span>{{ INT(item.client_type) }}</span>
      </template>
      <template #item.status="{ item }">
        <span>{{ INT(item.status) }}</span>
      </template>
      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-push-message-logs',
                'edit-push-message-logs',
                'delete-push-message-logs',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getMessageLogsDetailList } from "@/service/api/pushMessageLogs";
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      disabled: true,
      list: {},
      dialog: false,
      options: {
        pagesize: 5, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
        selectlist: [10, 20, 50, 100, 200],
        pagetext: this.$t("label_Each_page_shows"),
      },
      loading: false,
      desserts: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_staff_code"),
          value: "staff_code",
          sortable: false,
        },
        {
          text: this.$t("label_username"),
          value: "preferred_name",
          sortable: false,
        },
        {
          text: this.$t("label_The_title"),
          align: "start",
          value: "title",
          sortable: false,
        },
        {
          text: this.$t("label_Body"),
          align: "start",
          value: "body",
          sortable: false,
        },
        {
          text: this.$t("label_clientType"),
          align: "start",
          value: "client_type",
          sortable: false,
        },
        {
          text: this.$t("label_Is_read"),
          value: "is_read",
          sortable: false,
        },
        {
          text: this.$t("label_created_time"),
          value: "created_utc_datetime",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("label_changeStatus"),
          value: "status",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ];
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-push-message-logs"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-push-message-logs"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-push-message-logs"),
          type: "del",
        },
      ];
    },
  },
  beforeDestroy() {},
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  watch: {
    $route(v) {
      if (v.name == "pushMessagelog") {
        // console.log(v);
        this.getlist();
      }
    },
  },
  mounted() {
    // console.log(this.$route);
    this.getlist();
  },

  methods: {
    async getlist(obj) {
      this.loading = true;
      if (this.desserts.length == 1 && this.options.cpage != 1)
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;

        this.options = { ...this.options, ...obj };
      }
      const res = await getMessageLogsDetailList(
        Object.assign(
          {
            cpage: this.options.cpage,
            pagesize: this.options.pagesize,
            systemSeniorQueryString: this.systemSeniorQueryString,
            field_alias_name: this.field_alias_name,
            table_alias_name: this.table_alias_name,
          },
          this.$route.query.id
            ? {
                log_uuid: this.$route.query.id,
              }
            : {}
        )
      );
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    turnPage({ cpage, pagesize }) {
      this.options.cpage = cpage;
      this.options.pagesize = pagesize;
      this.getlist();
    },

    godetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit("set_subPage_name", item.template_name);
      this.$store.commit("set_uuid", item.uuid); //
      this.$router.push({
        name: "message-detailLog-detail",
      });
    },
    handleClick({ index }, item) {
      switch (index) {
        case 0:
          this.godetail(item);
          break;
        case 1:
          this.$store.commit("set_subPage_name", item.template_name);
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit("set_uuid", item.uuid); //
          this.$router.push({
            name: "message-detailLog-detail",
          });
          break;
      }
    },
  },
};
</script>


